module.exports = __webpack_public_path__ + "static/img/8areaB_05.ce25446.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_05.png
// module id = 1234
// module chunks = 1